import React from "react";
import { createInlineFallbackAvatar } from "../utils/teamMemberAvatar";

const MemberHeader = ({ member }) => (
  <div className="member-col">
    <img
      src={member.avatar}
      alt={member.name}
      className="member-avatar"
      onError={event => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = createInlineFallbackAvatar({ name: member.name, gender: member.gender });
      }}
    />
    <div className="member-name">{member.name}</div>
  </div>
);

export default MemberHeader;
